import { Col, Tile } from '@op/opds.opux';
import Donut from '../Donut/Donut';
import ProductTypeList from './ProductTypeList';
import classes from './ResultTile.module.scss';
import { ResultTileData } from '../interfaces/interfaces';
import { useIsMobile } from '../../../util/mediaQuery';

interface Props {
  title: string;
  data: ResultTileData[];
  isWide?: boolean;
}

const ResultTile = (props: Props): JSX.Element => {
  const { title, data, isWide } = props;
  const columnWidth = isWide ? 12 : 6;
  const minHeight = isWide ? undefined : '35rem';
  const isMobile = useIsMobile();

  return (
    <Col md={columnWidth} sm={12} className={classes.resolution}>
      {isWide ? (
        <h4 className="investoracademy-general-graph-title align-center">{title}</h4>
      ) : null}
      <Tile
        style={{
          display: 'flex',
          alignItems: 'center',
          minHeight,
        }}
      >
        <div
          className={classes.graphWrapper}
          style={{
            flexDirection: isWide && !isMobile ? 'row' : undefined,
          }}
        >
          {!isWide && (
            <h4 className="investoracademy-general-graph-title align-center">{title}</h4>
          )}
          <Donut isLarge data={data} />
          <ProductTypeList data={data} />
        </div>
      </Tile>
    </Col>
  );
};

export default ResultTile;
